import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ModalComponent } from "app/shared/components";

import { UserRole } from "@models/role.model";
import { Permission } from "@models/permission.model";
import { InternalPosition } from '@models/internal-position.model';

@Component({
    selector: 'app-roles-modal',
    templateUrl: './roles-modal.component.html',
    styleUrls: ['./roles-modal.component.scss']
})
export class RolesModalComponent implements OnInit {
    @ViewChild(ModalComponent, {static: true}) modal: ModalComponent;
    @Output('onUpdate')
    onUpdate: EventEmitter<any> = new EventEmitter();

    @Input() public role: UserRole;
    @Input() permissions: Permission[] = [];
    @Input() internalPositions: InternalPosition[] = [];
    @Input() shouldRenderModifiers: boolean;
    @Input() isLoading;

    form: UntypedFormGroup;

    error = false;
    previousRoleName = '';

    validationErrors;
    showValidations = false;

    constructor() {
    }

    ngOnInit() {
        this.form = new UntypedFormGroup({
            name: new UntypedFormControl('', [<any>Validators.required]),
            date: new UntypedFormControl('', [<any>Validators.required])
        });
    }

    /**
     * @param {any} role
     */
    open(role = new UserRole()) {
        this.reset();
        this.loadFormValue(role);
        this.modal.open();
    }

    close() {
        this.modal.close();
    }

    loadFormValue(role) {
        this.role = role;
        this.previousRoleName = role.name;
        this.form.setValue({name: this.getRoleName(role), date: new Date(2020, 2, 2)});
    }

    getFormValue() {
        return Object.assign(this.role, this.form.getRawValue());
    }

    updateRole() {
        if (!this.isFormValid()) {
            return;
        }
        this.onUpdate.emit({previousRoleName: this.previousRoleName, newRole: this.getFormValue()});
    }

    isOobRole() {
        return this.role && this.role.isOob;
    }

    getRoleName(role: UserRole) {
        return role.name;
    }

    private reset() {
        this.showValidations = false;
        this.validationErrors = {};
        this.form.reset();
    }

    private isFormValid() {
        this.validationErrors = {};
        this.showValidations = true;
        let isValid = true;

        Object.keys(this.form.controls).forEach(key => {
            const control = this.form.controls[key];
            if (control.invalid) {
                isValid = false;
            }
        });

        return isValid;
    }
}
